module.exports = __webpack_public_path__ + "img/sanat-o-madan.72ebc9b8.png";